import { useI18n } from '../../../i18n/index.js'
import { ChatAttachment } from '../../types.js'

interface Props {
  attachment: ChatAttachment
}

export const ComposerImageAttachmentItem = ({ attachment }: Props) => {
  const { $t } = useI18n()
  const url =
    attachment.uploadedFile?.url ?? URL.createObjectURL(attachment.file)
  const alt =
    attachment.uploadedFile?.name ??
    attachment.file?.name ??
    $t({
      defaultMessage: 'Image',
      id: 'Generics.Image',
    })

  return (
    <div className="p-1">
      <img src={url} alt={alt} className="rounded-lg w-[50px] h-[50px]" />
    </div>
  )
}
